import register from '@kpsys/angularjs-register';
import {KpSvelteComponentWrapperComponent} from './kp-svelte-component-wrapper.component';
import {svelteDefaultContextFactory} from './svelte-default-context.factory';


export default register('portaro.svelte-module')
    .factory(svelteDefaultContextFactory.factoryName, svelteDefaultContextFactory)
    .component(KpSvelteComponentWrapperComponent.componentName, KpSvelteComponentWrapperComponent)
    .name()
